/* eslint-disable */
export default {
  'signixfrontend': '7957efc3776852a1ff7cac2d463b85733096bfa26501285ca9f90b8c853363b6',
  '@signiapp/core': '1.5.268',
  '@signiapp/helpers': '0.3.10',
  '@signicat/designi': '^0.5.45',
  '@signiapp/contact': '1.0.5',
  '@signiapp/signature': '1.8.240',
};
